import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const MGB2BEditor = ({ plan, onChange }) => {
  const fields = [
    ...Object.entries(plan.b2b01_tiers).map(([tier, value]) => ({
      key: `b2b01-p${tier}`, label: `B2B01 · Palier ${tier}`, value: value.support_ht, tier,
    })),
    ...["B2B02", "B2B03"].map((category) => ({
      key: category.toLowerCase(), label: category, value: plan.b2b_supports_ht[category], category,
    })),
  ];
  const update = (field, rawValue) => {
    const value = Math.max(0, Number(rawValue) || 0);
    if (field.tier) {
      onChange({ ...plan, b2b01_tiers: { ...plan.b2b01_tiers,
        [field.tier]: { ...plan.b2b01_tiers[field.tier], support_ht: value } },
        b2b_supports_ht: { ...plan.b2b_supports_ht, ...(field.tier === "1" ? { B2B01: value } : {}) } });
    } else {
      onChange({ ...plan, b2b_supports_ht: { ...plan.b2b_supports_ht, [field.category]: value } });
    }
  };
  return (
    <div data-testid="admin-mg-b2b-editor" className="space-y-3">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {fields.map((field) => (
          <div key={field.key} className="space-y-1 min-w-0">
            <Label htmlFor={`mg-admin-${field.key}`} data-testid={`admin-mg-${field.key}-label`} className="text-xs">{field.label} · € HT</Label>
            <Input id={`mg-admin-${field.key}`} data-testid={`admin-mg-${field.key}-input`} type="number" min="0" step="0.01"
              value={field.value} onChange={(event) => update(field, event.target.value)} />
          </div>
        ))}
      </div>
      <p data-testid="admin-mg-quality-prime" className="text-xs text-muted-foreground">Prime qualité garantie : {plan.quality_prime_rate * 100} % du prix HT.</p>
    </div>
  );
};